module.exports = __webpack_public_path__ + "img/prozorska-grafika.d34685f0.jpg";